import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { UserPermissionsData, PortalSettingInfoData } from "@ServerTypes/portal/portal.schema";

export type { ResourceTypePermission, UserPermissionsData, PortalSettingInfoData } from "@ServerTypes/portal/portal.schema";

const userPermissionsSlice = createSlice({
  name: "userPermissions",
  initialState: {} as UserPermissionsData,
  reducers: {
    setUserPermissions: (_state: UserPermissionsData, action: PayloadAction<UserPermissionsData>) =>
      action.payload,
  },
});

const portalSettingInfoSlice = createSlice({
  name: "portalSettingInfo",
  initialState: {} as PortalSettingInfoData,
  reducers: {
    setPortalSettingInfo: (_state: PortalSettingInfoData, action: PayloadAction<PortalSettingInfoData>) =>
      action.payload,
  },
});

export const { setUserPermissions } = userPermissionsSlice.actions;
export const { setPortalSettingInfo } = portalSettingInfoSlice.actions;

export const userPermissions = userPermissionsSlice.reducer;
export const portalSettingInfo = portalSettingInfoSlice.reducer;
